/**
 * Created by fijas on 6/14/17.
 */
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

import {Search} from '../../utilities/construction-reports/Search';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from './common.service';

@Injectable()
export class ConstructionReportService {

    private constructionReportsUrl: string;  // URL to web api

    constructor(private http: HttpClient, private commonService: CommonService) {
        this.constructionReportsUrl = environment.apiBaseUrl + 'construction-reports';
    }

    getReports(page: number, searchModel: Search, isScavo: number) {
        let params = new HttpParams()
            .set('page', page)
            .set('isScavo', isScavo)
            .set('pageSize', '9')
            .set('expand', 'countries_list')
            .set('term', searchModel.term);

        const convertedData = this.commonService.convertDataFromTree(searchModel);

        if (convertedData.countries.length > 0) {
            params = params.set('countries', convertedData.countries);
        }
        if (convertedData.industries.length > 0) {
            params = params.set('industries', convertedData.industries);
        }

        return this.http.get(this.constructionReportsUrl, {params: params, observe: 'response'});
    }

    getReport(id: number | string) {
        const params = new HttpParams()
            .set('expand', 'country_string,countries_list,industry_string');
        return this.http.get(`${this.constructionReportsUrl}/${id}`, {params});
    }

    getUpcomingReports() {
        return this.http.get(this.constructionReportsUrl + '/upcoming');
    }

    saveReportDownload(report) {
        return this.http.post(this.constructionReportsUrl + '/save-download', {report_id: report});
    }

    emailReport(report) {
        return this.http.post(this.constructionReportsUrl + '/email', {report_id: report});
    }
}
